import AppBarUser from "../../components/AppBarUser";
import CustomDivider from "../../components/CustomDivider";
import Kanban from "../../components/Kanban";


export default function MinhasSolicitacoes() {
    return(
        <> 
            <AppBarUser title="Minhas Solicitações" />
            <CustomDivider />
            <Kanban />
        </>
    )
}